export const FLAG_GETTING_COMPANY_CREDIT_NOTES =
  'FLAG_GETTING_COMPANY_CREDIT_NOTES';
export const GET_COMPANY_CREDIT_NOTES = 'GET_COMPANY_CREDIT_NOTES';
export const CLEAR_COMPANY_CREDIT_NOTES = 'CLEAR_COMPANY_CREDIT_NOTES';
export const FLAG_COMPANY_CREDIT_NOTE_ACTIVITY =
  'FLAG_COMPANY_CREDIT_NOTE_ACTIVITY';
export const GET_COMPANY_CREDIT_NOTE = 'GET_COMPANY_CREDIT_NOTE';
export const CLEAR_COMPANY_CREDIT_NOTE = 'CLEAR_COMPANY_CREDIT_NOTE';
